module.exports = "/assets/data/04ec7f2b07f243f2de894b0621cc665b-DE75.data.json";